const MarkdownIt = require("markdown-it");
module.exports = str => {
  if (!str) return "";
  const md = new MarkdownIt();
  return md.render(str);
};
